
export class TransactionHistoryModel {
    TxnHistory: TransactionReport[];
    Count:number;
    CardSaleAmt:number;
    BankPgLoadAmt:number;
    NEFTRTGSLoadAmt:number;
    CCMSSaleAmt:number;
    CardBalanceAmt:number;
}
export class TxnHistoryModel {
    TransactionId: string;
    CardNumber: string;
    TransactionDate: string;
    TransactionDateOnly: string;
    OutletName: string;
    TxnAmount: string;
    TransactionType: string;
    TransactionTypeId: number;
    VehicleRegistrationNo:string;
    QTY:string;
    Status:string;
    BaseAmount:number;
    BalanceLeft:number;
    VehicleNo:string;
    Product:string;
    Rate:Number;
}

export class CustomerTxnReportSearch {
    public Startdate: Date;
    public EndDate: Date;
    public IsSpend: number;
    public IsLoad: number;
    public IsActivation: number;
    public SelectedTerminalNo: string;
    public MerchantId: string;
    public MerchantName: string;
    public IsShiftChecked: boolean;
    public  IsSift1 : number;
    public  IsSift2 : number;
    public  IsSift3 : number;

    constructor() {
        this.Startdate = new Date();
        this.EndDate = new Date();
        //this.SelectedTerminalNo;
        this.IsSpend=0;
        this.IsLoad=0;
        this.IsActivation=0;
        this.IsSift1=0;
        this.IsSift2=0;
        this.IsSift3=0;
        this.IsShiftChecked=false;
        //this.MerchantName = '';
    }
}


export class TransactionReport {
    public CustometId: number
    public CustomerCode: string
    public MobileNo: string
    public CustomerName: string
    public CardNumber: string
    public LoadMoneyAmount: number
    public CardCashLoadAmount: number
    public PayMentGetwayAmount: number
    public NEFT_RTGSAmount: number
    public TxnDate: string
    public CardSale: number
    public TxnTypeName: string
    public TxnAmount: number
    public OutletName: string
    public MerchantName: string
    public TransactionId: number
    public VehicleNo: string
    public CardSaleAmount: number
    public OtherSaleAmount: number
    public BankPgLoadAmount: number
    public CashLoadAmount: number
    public OtherLoadAmount: number
    public ShiftId: string
    public TerminalNumber: string
    public NoOFCards: number
    public Sale1: number
    public Sale2: number
    public GrowthPercentage: number
    public QTY: string
    public NeftRtgsLoadAmt: number
    public CCMSSaleAmt: number
    public CardBalance: number
    public CCMSBalance: number
    public Address: number
    public StatementPeriod:number;
    public DaysName: string;
    public CNGQuantity: string;
    constructor(){
        this.StatementPeriod=23601;
    }
}

export class CustomerSearchFilterModel {
    public CustomerName: string;
    public CustomerId: string;
}


// WEBPACK FOOTER //
// ./src/app/models/customer-transaction-history/TransactionHistoryModel.ts